import { HestiaFhirResource } from '@hestia/ngx-types';

export const initialFhirResources: HestiaFhirResource[] = [];
